import React, { useState, useEffect, useRef } from 'react';
import BankIdModalBackoffice from 'modules/BankIdModal/BankIdModalBackoffice';
import { useMiddleman, csrf } from '@hubins/middleman';

// const returnUrl = encodeURIComponent(window.location.href);

const BackofficeBankID = ({
  nationalIdentityNumber,
  callback,
  abortCallback,
  callInitiator,
}) => {
  const middleman = useMiddleman();

  const [reference, setReference] = useState(false);
  const [error, setError] = useState(false);
  const [signStatus, setSignStatus] = useState('init');

  const aborted = useRef(false);
  const abortController = useRef(new AbortController());

  const processCallback = (res) => {
    if (res.authReference) {
      setReference(res.authReference);
    }
  };

  const fetchData = async () => {
    aborted.current = false;
    await csrf();
    middleman
      .promiseKeepAlivePost('/ql/crm/bankid/init', {
        ssn: nationalIdentityNumber,
        callInitiator,
      }, abortController.current.signal)
      .then(res => processCallback(res))
      .catch(e => {
        setError(true);
        console.error('INITERROR: ', e.message);
      });
  };

  const resetBankID = async () => {
    abortController.current.abort();
    abortController.current = new AbortController();
    if (reference) {
      await middleman.promisePost('/ql/crm/bankid/abort', { authReference: reference });
    }
    setReference(false);
    setSignStatus('init');
  };

  useEffect(() => {
    if (signStatus === 'init') {
      setError(false);
      setReference(false);
      setSignStatus('pending');
      fetchData();
    }

  }, [signStatus]);

  const poll = () => {
    middleman
      .promiseKeepAlivePost('/ql/crm/bankid/status', {
        authReference: reference
      }, abortController.current.signal)
      .then(response => {
        if (response.httpStatus === 200) {
          setTimeout(poll, 1000);
          return;
        }
        if (response.httpStatus === 201) {
          setSignStatus('complete');
          if (callback) {
            callback(response);
          }
          return;
        }

        if (response.httpStatus === 410 && !aborted.current) {
          fetchData();
        }

        return;
      }).catch(e => {
        setError(true);
        console.error('STATUSERROR', e);
      });
  };

  useEffect(() => {
    if (reference) {
      poll();
    }
  }, [reference]);

  const handleAbort = async () => {
    if (abortCallback) {
      abortCallback();
    }
    aborted.current = true;
    abortController.current.abort();
    abortController.current = new AbortController();
    setReference(false);
    middleman.promisePost('/ql/crm/bankid/abort', { authReference: reference });
  };

  return (
    <BankIdModalBackoffice
      open={true}
      error={error}
      platform={'Hubins'}
      handleSubmit={() => { setReference(false); }}
      handleErrorSubmit={resetBankID}
      handleAbort={handleAbort}
    />
  );
};

export default BackofficeBankID;
